import { useCallback, useEffect } from 'react';
import { useDispatchingUI } from 'modules/dispatching/ui';

const BiddingVisibilityHandler = ({ biddingEventEmitter, biddingEvents }) => {
  const { mutateListFn } = useDispatchingUI();

  const handleMutate = useCallback(() => {
    if (!mutateListFn) {
      return;
    }
    mutateListFn();
  }, [mutateListFn]);

  useEffect(() => {
    biddingEventEmitter.on(biddingEvents.BIDDING_VIEWED, handleMutate);
    return () => {
      biddingEventEmitter.off(biddingEvents.BIDDING_VIEWED, handleMutate);
    };
  });

  return null;
};

export default BiddingVisibilityHandler;
